import React from 'react';
import {Redirect, Route, Switch,asyncComponent} from '../../../components';
const BannerImage = ({match}) => (
  <div className="app-wrapper">
    <Switch>
      <Redirect exact from={`${match.url}/`} to={`${match.url}/list`}/>
      <Route path={`${match.url}`} component={asyncComponent(() => import('./routes/'))}/>
      <Route component={asyncComponent(() => import('app/routes/extraPages/routes/404'))}/>
    </Switch>
  </div>
);

export default BannerImage;
